import { fourierConfig as config } from "../config";

export const CircleCounter = ({
  count,
  opacity = 1,
  colors = config.colors,
}: {
  count: number;
  opacity?: number;
  colors?: { text: string; circle: string };
}) => (
  <div
    style={{
      position: "absolute",
      left: 96,
      top: 305,
      color: colors.text,
      opacity,
    }}
  >
    <div style={{ display: "flex", alignItems: "baseline", gap: 25 }}>
      <span
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: 162,
          fontWeight: 700,
          lineHeight: 1,
          letterSpacing: -8,
        }}
      >
        {count}
      </span>
      <span
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: 39,
          fontWeight: 400,
          letterSpacing: 6,
          color: colors.circle,
        }}
      >
        {count === 1 ? "CIRCLE" : "CIRCLES"}
      </span>
    </div>
  </div>
);
